import React, { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Button, Modal, Form } from "react-bootstrap"
import Select from "react-select"
import PaginationTable from "../../components/paginationTable"
import SearchBar from "../../components/searchBar"
import {
    chatbotLeads,
    chatbotLeadsCount
} from "../../actions/commonController"
import { useAuth } from "../../context/authContext"
import { utcDate, formatDate } from "../../config/utcDate"
import { isEmpty } from "../../config/funcs"

const ChatbotLeads = () => {
    const [data, setData] = useState([])
    const [showCreateModal, setShowCreateModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [userToDelete, setUserToDelete] = useState(null)
    const [totalItems, setTotalItems] = useState(0)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [page, setPage] = useState(1)
    const [quantity, setQuantity] = useState(10)
    const [searchTerm, setSearchTerm] = useState("")
    const [modalLoader, setModalLoader] = useState(false)
    const [editModalLoader, setEditModalLoader] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [loader, setLoader] = useState(false)
    const [initLoad, setInitLoad] = useState(false);
    const { eid } = useAuth

    const handlePageChange = (page) => {
        setPage(page)
    }

    const handleItemsPerPageChange = (newItemsPerPage) => {
        setQuantity(newItemsPerPage)
        setPage(1)
    }

    const handleDelete = (userId) => {
        setUserToDelete(userId)
        setShowDeleteModal(true)
    }

    const initialization = async () => {
        try {
            setLoader(true)
            let { status, data } = await chatbotLeadsCount()

            if (status === "success") {
                setTotalItems(data)
                await loadData()
                setInitLoad(true)
            }
        } catch (err) {
            console.error("Error in loadData function", err)
        }
    }

    const loadData = async () => {
        try {
            let APIData = {
                page: page,
                quantity: quantity,
            }

            setLoader(true)
            const { data } = await chatbotLeads(APIData)
            setData(data)
            setPage(page)
        } catch (error) {
            console.error("Error fetching users:", error)
        } setLoader(false)
    }

    useEffect(() => {
        if (initLoad) loadData()
    }, [page, quantity])

    useEffect(() => {
        initialization()
    }, [])

    return (
        <div className="container-fluid">

            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title">Chatbot Leads Management</h4>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            {loader ? (
                                <div className="text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-centered table-hover table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>S. No</th>
                                                <th>Name</th>
                                                <th>Phone No.</th>
                                                <th>Email</th>
                                                <th>Salary</th>
                                                <th>DOB</th>
                                                <th>Requested At</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((chatbot) => (
                                                <tr key={chatbot.id}>
                                                    <td>{chatbot.id}</td>
                                                    <td>{chatbot.name}</td>
                                                    <td>{chatbot.phone}</td>
                                                    <td>{chatbot.email}</td>
                                                    <td>{chatbot.salary}</td>
                                                    <td>{!isEmpty(chatbot.dob) ? formatDate(utcDate(chatbot.dob)) : "-"}</td>
                                                    <td>{!isEmpty(chatbot.createdAt) ? formatDate(utcDate(chatbot.createdAt)) : "-"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {data.length === 0 && (
                                        <div className="text-center py-4">
                                            <p>No leads found.</p>
                                        </div>
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                    {/* Pagination Component */}
                    <PaginationTable
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        pageChange={handlePageChange}
                        onItemsPerPageChange={handleItemsPerPageChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default ChatbotLeads
